export default __webpack_public_path__ + "static/media/unknown.e8a7746e.svg";